/**
 * List of possible templates options of the "extended select" component
 */
export enum ExtendedSelectType {
    avatar = 'avatar',
    default = 'default',
    group = 'group',
    link = 'link'
}
